export const isInStoreSelector = state => !!state.staffInfo?.userAccount;
